/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "../components/ui";
import { getEducationalPosts } from "api";
import Post from "components/common/post";
import LoadingOverlay from "components/common/LoadingOverlay";
import { style } from "layouts/LandingLayout";
import { Link } from "react-router-dom";
import Pagination from "components/common/Pagination";

const scrollUp = () => {
  window.scrollTo(0, 0);
};

const filter = {
  authorIds: [],
  educationOnly: false,
  searchString: "4 Year Journey",
  applySearchStringTo: {
    title: false,
    content: false,
    excerpt: false,
    tags: true
  }
};

const FourYearJourney = () => {
  const [posts, setPosts] = useState([]);
  const [loader, setLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLoader(true);
    getEducationalPosts(filter, 2, 0)
      .then(res => {
        setLoader(false);
        setPosts(res.data.items);
        setTotal(res ? res.data.total : 0);
      })
      .catch(e => {
        console.log(e);
      });
  }, []);

  const handlePageChange = async pageNumber => {
    scrollUp();
    setLoader(true);
    setActivePage(pageNumber);
    const posts = await getEducationalPosts(filter, 2, pageNumber - 1);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
    setPosts(posts.data.items);
    setTotal(posts ? posts.data.total : 0);
  };

  if (loader) {
    return (
      <LoadingOverlay
        active={loader}
        text={"Loading all 4-year journey posts, please wait..."}
      />
    );
  }

  return (
    <Container style={{ padding: "50px 10px" }}>
      <Row>
        <Col>
          <h3 style={{ marginBottom: 30 }} className="text-center">
            4-YEAR JOURNEY
          </h3>
          <br />
        </Col>
      </Row>
      {posts.length > 0 ? (
        <>
          <div
            style={{
              margin: window.screen.width > 768 ? "0% 21%" : "0% 7.5%",
              borderLeft: "1px solid #ebebeb",
              borderRight: "1px solid #ebebeb",
              padding: window.screen.width > 768 ? "0px 55px" : "0px 0px"
            }}
            id={"post-wrapper"}
          >
            {posts.map((post, idx) => (
              <>
                <Link
                  to={`/analyst/${post.author.slug}`}
                  className="card-post__author-avatar card-post__author-avatar--small"
                  style={{
                    backgroundImage: `url('${post.author.avatar.small}')`,
                    zIndex: 10,
                    width: window.screen.width > 768 ? 65 : 40,
                    height: window.screen.width > 768 ? 65 : 40,
                    position: "absolute",
                    marginLeft: window.screen.width > 768 ? "-90px" : "-19px"
                  }}
                ></Link>
                <Post key={idx} col={"12"} post={post} />
              </>
            ))}
            <label className="pagelabel">
              Page {activePage} of {Math.ceil(total / 2)}
            </label>
          </div>
          <div
            className="paginationDiv"
            style={{
              borderRight: "1px solid rgb(235, 235, 235)",
              width: window.screen.width > 768 ? "58%" : "85%",
              margin: window.screen.width > 768 ? "0% 21%" : "0% 7.5%"
            }}
          >
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={activePage}
              itemsCountPerPage={2}
              totalItemsCount={total}
              pageRangeDisplayed={window.screen.width < 500 ? 1 : 3}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </>
      ) : (
        <Row>
          <Col>
            <h5 style={{ marginBottom: 30 }} className="text-center">
              No Posts to Display
            </h5>
            <br />
          </Col>
        </Row>
      )}
      <br />
      <br />
      <br />
      <Row>
        <Col className="text-center text-md-left">
          <h4>4-YEAR JOURNEY MODEL PORTFOLIO</h4>
          <br />
        </Col>
      </Row>
      <Row className="d-lg-none text-center">
        <Col>
          <a
            href="https://docs.google.com/spreadsheets/d/1VYWi-e2O9tX2gys8fyZI57i3ePfy6C9EhR1K8FFwLu8/edit#gid=0&amp;range=A2:G35?widget=true&amp;headers=false"
            target="_blank"
            className="bitcoin-linear"
            rel="noopener noreferrer"
            style={{
              ...style.defaultLink,
              margin: 0,
              padding: "10px 16px"
            }}
          >
            Model Portfolio Google Sheet
          </a>
        </Col>
      </Row>
      <Row className="d-none d-lg-block">
        <Col>
          <iframe
            src="https://docs.google.com/spreadsheets/d/1VYWi-e2O9tX2gys8fyZI57i3ePfy6C9EhR1K8FFwLu8/edit#gid=0&amp;range=A2:G35?widget=true&amp;headers=false"
            frameborder="0"
            width="100%"
            height="650"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </Col>
      </Row>
      {scrollUp()}
    </Container>
  );
};

FourYearJourney.propTypes = {};

FourYearJourney.defaultProps = {};

export default FourYearJourney;
